<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.7 15a1.5 1.5 0 0 1-2.12 0L.86 10.29a2.93 2.93 0 0 1 0-4.14L5.58 1.4A1.5 1.5 0 0 1 7.7 3.53L4.47 6.7h14.21A5.33 5.33 0 0 1 24 12.02v6.68a5.3 5.3 0 0 1-5.32 5.32H5.32a1.5 1.5 0 1 1 0-3h13.36A2.3 2.3 0 0 0 21 18.7v-6.68a2.3 2.3 0 0 0-2.32-2.32H4.52l3.18 3.19a1.5 1.5 0 0 1 0 2.12"/></svg>
</template>
